import { render } from "./QiBingPage.vue?vue&type=template&id=ff7c1862&scoped=true"
import script from "./QiBingPage.vue?vue&type=script&lang=js"
export * from "./QiBingPage.vue?vue&type=script&lang=js"

import "./QiBingPage.vue?vue&type=style&index=0&id=ff7c1862&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff7c1862"]])

export default __exports__